import {
  CreateBetExcelUploadType,
  CreateBetGameSettingType,
  CreateBetGameSettingType1,
  CreateConfigSettingType,
  CreateJackpotType,
  CreateJackpotSettingType,
  CreateSmallWinSettingType,
  CreateJackpotWalletType,
} from '@/types/bet/create-type';
import { axiosDelete, axiosPost } from '../AxiosApi';
import { sendRequest } from '../AxiosRequest';

export const createBetGameSetting = async (createBetGameSetting: CreateBetGameSettingType) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/game-setting',
    body: { ...createBetGameSetting },
  };
  return await sendRequest(payload, 'createBetGameSetting', axiosPost);
};
// 잭팟 생성 방식 변경(기존: 지갑 주소, 금액, 변경: 지갑 주소, 금액, 랭킹)
// export const createJackpot = async (createJackpot: CreateJackpotType[]) => {
//   console.log(createJackpot);
//   const payload = {
//     apiUrl: process.env.REACT_APP_MINIGAME_URL,
//     path: '/admin-bet/jackpot-pay',
//     body: createJackpot,
//   };
//   return await sendRequest(payload, 'createJackpot', axiosPost);
// };

export const createBetExcelUpload = async (createBetExcelUploadType: CreateBetExcelUploadType[]) => {
  const payload = {
    path: '/admin-point-bet',
    body: createBetExcelUploadType,
  };
  return await sendRequest(payload, 'createBetExcelUpload', axiosPost);
};

export const createBetPoint = async (createBetPoint: CreateJackpotType[]) => {
  console.log(createBetPoint);
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/admin-bet',
    body: createBetPoint,
  };
  return await sendRequest(payload, 'createBetPoint', axiosPost);
};

export const createSmallWinSetting = async (createSmallWinSetting: CreateSmallWinSettingType) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/game-setting/small-setting',
    body: { ...createSmallWinSetting },
  };
  return await sendRequest(payload, 'createSmallWinSetting', axiosPost);
};

export const deleteSmallWinSetting = async (smallSetId: string) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: `/game-setting/small-setting`,
    body: { smallSetId },
  };
  return await sendRequest(payload, 'deleteSmallWinSetting', axiosDelete);
};

export const createConfigSetting = async (createConfigSetting: CreateConfigSettingType) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/game-setting/config',
    body: { ...createConfigSetting },
  };
  return await sendRequest(payload, 'createConfigSetting', axiosPost);
};

export const deleteConfigSetting = async (configId: string) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: `/game-setting/config`,
    body: { configId },
  };
  return await sendRequest(payload, 'deleteConfigSetting', axiosDelete);
};

export const createJackpotSetting = async (createJackpotSetting: CreateJackpotSettingType) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/game-setting/jackpot',
    body: { ...createJackpotSetting },
  };
  return await sendRequest(payload, 'createJackpotSetting', axiosPost);
};

export const deleteJackpotSetting = async (jackpotId: string) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: `/game-setting/jackpot`,
    body: { jackpotId },
  };
  return await sendRequest(payload, 'deleteJackpotSetting', axiosDelete);
};

export const createJackpotWallet = async (createJackpotWallet: CreateJackpotWalletType[]) => {
  const payload = {
    apiUrl: process.env.REACT_APP_MINIGAME_URL,
    path: '/admin-bet/jackpot-rank',
    body: createJackpotWallet,
  };
  return await sendRequest(payload, 'createJackpotWallet', axiosPost);
};
